<template>
  <div>
    <AccountLoginForm/>
  </div>
</template>

<script>
import AccountLoginForm from "@/components/account/AccountLoginForm.vue";

export default {
  components: {
    AccountLoginForm,
  },
};
</script>

<style>

</style>